import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getFunnels, createFunnel, resetCreation, resetNewFunnel } from "../store/actions/homeActions";
import { Redirect } from 'react-router-dom';
import { Link } from "react-router-dom";

import moment from 'moment';
import LOADER from "../assets/images/loader.svg";



import { getSettings, updateSettings, resetErrorMessage, resetSettingsUpdated } from "../store/actions/settingsAction";


import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import { useFilters } from "react-table";




function Settings(props) {

    const { token, settings, getSettingsFN, updateSettingsFN, resetErrorMessageFN, resetSettingsUpdatedFN, settings_updated, error_message } = props;


    useEffect(() => {
        setSuccess(null);
        setError(null);

        resetSettingsUpdatedFN();
        resetErrorMessageFN();
        getSettingsFN();
    }, []);
    


    const handleSubmit = (e) => {

        resetErrorMessageFN();
        resetSettingsUpdatedFN();
        e.preventDefault();
        // Handle form submission logic here (e.g., dispatch an action to update user profile)
        ////console.log("Settings updated:", { timezone, currency, currentPassword, newPassword, confirmNewPassword });
        updateSettingsFN({ timezone, currency, currentPassword, newPassword, confirmNewPassword });
        //setSuccess("Settings saved successfully");
    };

    const [timezone, setTimezone] = useState(settings.timezone);
    const [currency, setCurrency] = useState(settings.currency);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    
    useEffect(() => {
        if(error_message) {
            setError(error_message);
        }
    }, [error_message]);

    useEffect(() => {
        if(settings) {
        
            ////console.log(settings);
            setTimezone(settings.timezone);
            setCurrency(settings.currency); 
            
        }
    }, [settings]);

    useEffect(() => {
        if(settings_updated) {
            setSuccess("Settings saved successfully");
        }
        
        
    }, [settings_updated]);

    //////console.log(settings_updated);

    return token ? (

        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full">
                <Sidebar className="fixed top-0 left-0 h-screen pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
                <div id="dashboard-content" className="flex flex-col w-full p-4 overflow-auto"
                > {/* Adjust the margin-left to match Sidebar width */}

                    <form onSubmit={handleSubmit} className="flex flex-col space-y-4 p-4">
                        
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Timezone</label>
                            <select
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                required
                                value={timezone}
                                onChange={(e) => setTimezone(e.target.value)}
                            >
                                <option value="">Select Timezone</option>
                                <option value="GMT-12:00">GMT-12:00</option>
                                <option value="GMT-11:00">GMT-11:00</option>
                                <option value="GMT-10:00">GMT-10:00</option>
                                <option value="GMT-9:00">GMT-9:00</option>
                                <option value="GMT-8:00">GMT-8:00</option>
                                <option value="GMT-7:00">GMT-7:00</option>
                                <option value="GMT-6:00">GMT-6:00</option>
                                <option value="GMT-5:00">GMT-5:00</option>
                                <option value="GMT-4:00">GMT-4:00</option>
                                <option value="GMT-3:00">GMT-3:00</option>
                                <option value="GMT-2:00">GMT-2:00</option>
                                <option value="GMT-1:00">GMT-1:00</option>
                                <option value="GMT+0:00">GMT+0:00</option>
                                <option value="GMT+1:00">GMT+1:00</option>
                                <option value="GMT+2:00">GMT+2:00</option>
                                <option value="GMT+3:00">GMT+3:00</option>
                                <option value="GMT+4:00">GMT+4:00</option>
                                <option value="GMT+5:00">GMT+5:00</option>
                                <option value="GMT+6:00">GMT+6:00</option>
                                <option value="GMT+7:00">GMT+7:00</option>
                                <option value="GMT+8:00">GMT+8:00</option>
                                <option value="GMT+9:00">GMT+9:00</option>
                                <option value="GMT+10:00">GMT+10:00</option>
                                <option value="GMT+11:00">GMT+11:00</option>
                                <option value="GMT+12:00">GMT+12:00</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Currency</label>
                            <select
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                required
                                value={currency}
                                onChange={(e) => setCurrency(e.target.value)}
                            >
                                <option value="">Select Currency</option>
                                <option value="USD">USD - United States Dollar</option>
                                <option value="EUR">EUR - Euro</option>
                                <option value="GBP">GBP - British Pound Sterling</option>
                                <option value="JPY">JPY - Japanese Yen</option>
                                <option value="AUD">AUD - Australian Dollar</option>
                                <option value="CAD">CAD - Canadian Dollar</option>
                                <option value="CHF">CHF - Swiss Franc</option>
                                <option value="CNY">CNY - Chinese Yuan</option>
                                <option value="SEK">SEK - Swedish Krona</option>
                                <option value="NZD">NZD - New Zealand Dollar</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Current Password</label>
                            <input
                                type="password"
                                placeholder="Enter current password"
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">New Password</label>
                            <input
                                type="password"
                                placeholder="Enter new password"
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
                            <input
                                type="password"
                                placeholder="Confirm new password"
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                value={confirmNewPassword}
                                onChange={(e) => setConfirmNewPassword(e.target.value)}
                                
                            />
                        </div>
                        
                        
                        
                        <button type="submit" className="mt-4 bg-[#3b3b3b] text-white p-2 rounded-md w-64 hover:opacity-80 transition-opacity">Save Settings</button>
                    </form>
                    {error && <div className="text-red-500 p-4">{error}</div>}
                    {success && <div className="text-green-500 p-4">{success}</div>}
                </div>
            </div>
        </div>
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        settings: state.settings.settings,
        error_message: state.settings.error_message,
        settings_updated: state.settings.settings_updated,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getSettingsFN: () => dispatch(getSettings()),
        updateSettingsFN: (settings) => dispatch(updateSettings(settings)),
        resetErrorMessageFN: () => dispatch(resetErrorMessage()),
        resetSettingsUpdatedFN: () => dispatch(resetSettingsUpdated()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Settings);
